import app from "app.controller"
import Filter from "components/Filter/Filter"
import ProductCol from "components/Product/ProductCard"
import SearchBar from "components/Search/SearchBar"
import SearchBarWithOptions from "components/Search/SearchBarWithOptions"
import Spinner from "components/Spinner/Spinner"
import PropTypes from "prop-types"

import queryString from "qs"
import React, {Component} from "react"
import {browserHistory} from "react-router-dom"
import {Card, Container, Message, Segment} from "semantic-ui-react"
import cmsStore from "stores/cmsStore"
import historyStore from "stores/historyStore"
import productStore from "stores/productStore"
import settingStore from "stores/settingStore"

export default class ActionsPage extends Component {
	constructor( props ) {
		super()
		let search = queryString.parse( props.location.search, {ignoreQueryPrefix: true} )
		this.state = {
			loading : true,
			search  : search.q || props.match.params.searchTerm || "",
			products: [],
			filter  : {
				total      : 64,
				pageSize   : 64,
				currentPage: 1,
			}, query: {
				q    : search.q || "",
				page : search.page || 1,
				count: search.count || 10,
			}

		}

		this.load()
		app.search.change.add( this.handleSearch )
	}

	componentWillReceiveProps( nextProps, nextContext ) {
		if ( this.state.search === nextProps.match.params.searchTerm ) return
		this.setState( {
			search: nextProps.match.params.searchTerm
		}, () => {
			this.load( {} )
		} )
	}

	handleSearch = ( e = {} ) => {
		let q = ""
		if ( e.target && e.target.value ) q = e.target.value
		if ( e.q ) q = e.q

		let query = this.state.query

		if ( this.state.search !== e ) {
			query.page = 1
		}

		this.setState( {search: q, query}, () => {
			if ( q.length >= 3 ) {
				this.load()
			} else {
				this.setState( {
					products: [],
					size    : 0
				} )
				return
			}
		} )
	}

	onChangeFilter = ( filter ) => {
		this.updateQuery( filter )
	}

	addQuery( query ) {
		this.props.history.replace( `${this.props.location.pathname}?${queryString.stringify( query )}` )
		return query
	}

	updateQuery( {page, dir, sort, pageSize} ) {
		let query = this.state.query
		query.page = page || query.page
		query.dir = dir || query.dir
		query.count = pageSize || query.count
		query.sort = sort || query.sort
		query.q = this.props.match.params.searchTerm

		this.addQuery( query )
		this.setState( {query}, () => {
			this.load()
		} )
	}

	load() {
		let {query} = this.state
		historyStore.set( {
			link   : `/search?q=${this.state.search}`,
			content: `${translate( "zurück zur Suche" )} "${this.state.search}"`,
		} )

		let additionalFilters = [
			{
				extra: true,
				field: "sale_cat",
				op   : "equals",
				value: this.state.search
			}
		]

		// if ( cmsStore.config.plugin.hideVariants ) {
		//   // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
		//   let noVariants = {
		//     op:    "equals",
		//     field: "type",
		//     value: "1"
		//   }
		//   const singleItems = { "field": "mainArticle", "op": "equals", "value": "" }
		//   let combinedFilter = [{ "or": [singleItems, noVariants] }]
		//   additionalFilters = additionalFilters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
		// }

		this.setState( {err: false, loading: true} )
		productStore.search( "%%", {
				filter: additionalFilters,
				count : 64,
				page  : query.page,
				sort  : query.sort,
				dir   : query.dir,
				artnr : 0
			}, {} )
			.then( response => {
				let {query} = this.state
				query.q = this.state.search
				let {products = []} = response

				this.setState( {
					size   : response.size,
					products,
					loading: false
				} )
				this.addQuery( query )
			} )
			.catch( err => {
				this.setState( {err: "Fehler bei der Anfrage", loading: false} )
			} )
	}

	componentWillUnmount() {
		app.search.change.remove( this.handleSearch )
	}

	render() {

		const query = queryString.parse( this.props.location.search.slice( 1 ) )


		let filter = {
			currentPage: Number( this.state.query.page ),
			total      : Number( this.state.size ),
			brand      : String( this.state.query.brand ),
			pageSize   : 64,
			dir        : this.state.query.dir || "desc",
			sort       : String( this.state.query.sort || "sort" )
		}

		const {loading} = this.state
		const {lastSearchURL} = productStore

		let filterSection = <section className="cf pb3">
			<Filter hidePageSize={true} onChange={this.onChangeFilter} {...filter} />
		</section>

		const {products, search} = this.state

		return (
			<div className="SearchPage">
				<div className="pt4-ns pt2">
					<Container>
						<h1><span className="ttu">{search}</span></h1>

						{/*<div className="mw6 center">*/}
						{/*<SearchBar/>*/}
						{/*</div>*/}
						{this.state.size > 0 ? filterSection : null}
						{loading && <Spinner />}
						<section className="mb5">
							{!loading && <div>{(!loading && products && products.length > 0) ? null : <div className="tc pa4">{translate( "Keine Produkte gefunden." )}</div>}</div>}
							{this.state.err && <Message>{`${this.state.err}`}</Message>}
							{!loading && <Card.Group itemsPerRow={4} doubling>
								{this.state.products.map( product => <ProductCol
									referer={"/aktionen/"}
									sm="1/2"
									key={product.map_id}
									product={product} /> )
								}
							</Card.Group>
							}
						</section>
						{this.state.size > 0 ? filterSection : null}
					</Container>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/ActionsPage.js